import { useEffect } from 'react';
import { useThemeStore } from './store';
import { applyTheme } from './apply-theme';

/**
 * Initializes design tokens from the theme store on mount and re-applies
 * them whenever the user changes a setting. Also listens to OS dark-mode
 * changes when mode === 'system'.
 *
 * Mount this once near the root, ABOVE the router. It renders no markup.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const presetId = useThemeStore((s) => s.presetId);
  const mode = useThemeStore((s) => s.mode);
  const density = useThemeStore((s) => s.density);
  const radius = useThemeStore((s) => s.radius);
  const customPrimary = useThemeStore((s) => s.custom.primary);
  const sidebarStyle = useThemeStore((s) => s.sidebarStyle);

  useEffect(() => {
    applyTheme({ presetId, mode, density, radius, customPrimary, sidebarStyle });
  }, [presetId, mode, density, radius, customPrimary, sidebarStyle]);

  useEffect(() => {
    if (mode !== 'system') return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () =>
      applyTheme({ presetId, mode, density, radius, customPrimary, sidebarStyle });
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [presetId, mode, density, radius, customPrimary, sidebarStyle]);

  return <>{children}</>;
}
